<template>
  <div :class="appClass">
    <svg style="display:none;">
      <defs>
        <filter id="dropshadow" height="130%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="5"/> <!-- stdDeviation is how much to blur -->
          <feOffset dx="0" dy="0" result="offsetblur"/> <!-- how much to offset -->
          <feComponentTransfer>
            <feFuncA type="linear" slope="0.9"/> <!-- slope is the opacity of the shadow -->
          </feComponentTransfer>
          <feMerge>
            <feMergeNode/> <!-- this contains the offset blurred image -->
            <feMergeNode in="SourceGraphic"/> <!-- this contains the element that the filter is applied to -->
          </feMerge>
        </filter>
      </defs>
    </svg>

    <HomeControls v-if="usesHomeControl" />
    <div :class="contentClass" ref="content" :style="contentStyle">
      <router-view/>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import HomeControls from '@/components/HomeControls'
import { isProd } from '@/utils'

export default {
  components: {
    HomeControls,
  },
  data () {
    return {
      windowHeight: null,
      windowWidth: null,
    }
  },
  async created () {
    await this.initApp()
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    usesHomeControl () {
      return this.$route.meta.control === 'home'
    },
    appClass () {
      return [this.$style.app, {
        [this.$style.app_home]: this.usesHomeControl,
      }]
    },
    contentClass () {
      return [this.$style.content, {
      }]
    },
    contentStyle () {
      const wScale = (this.windowWidth - 104) / 1024.0
      const hScale = this.windowHeight / 768.0

      if (wScale >= 1 && hScale >= 1) {
        return false
      }

      let transform = []
      if (wScale < 1) {
        transform.push(`scaleX(${wScale})`)
      }
      if (hScale < 1) {
        transform.push(`scaleY(${hScale})`)
      }

      return {
        transform: transform.join(' '),
      }
    },
    ...mapGetters('auth', {
      authed: 'authed',
    }),
  },
  methods: {
    async initApp () {
      if (this.authed) {
        await Promise.all([
          this.getProfile(),
          this.getItems(),
        ])
      }
    },
    handleResize () {
      this.windowWidth = window.innerWidth
      this.windowHeight = window.innerHeight

      // this.contentWidth = this.$refs.content.offsetWidth
      // this.contentHeight = this.$refs.content.offsetHeight
    },
    ...mapActions('auth', {
      getProfile: 'getProfile',
    }),
    ...mapActions('shop', {
      'getItems': 'getItems',
    }),
  },
  watch: {
    'authed' (newValue) {
      if (!newValue) {
        this.$router.replace('/login')
      }
    },
  },
}
</script>

<style lang="scss" module>
html, body {
  @apply m-0;
  @apply h-full;
  font-family: 'Noto Sans TC', sans-serif;
}

.app {
  background-color: #f4c15963;
  @apply overflow-y-hidden;
  @apply select-none;
  @apply relative;
  height: 100vh;
  box-sizing: border-box;
}

.app_home {
  padding-left: 104px;
}

.content {
  @apply h-full;
  @apply w-full;
  min-width: 1024px;
  min-height: 768px;
  transform-origin: 0 0;
  @apply relative;
}
</style>
